"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNameAndSymbolERC721 = exports.getNameAdSymbolAndDecimalsERC20 = void 0;
const web3Factory_1 = require("./web3Factory");
const erc20_abi_1 = require("../../abi/erc20.abi");
const erc721_abi_1 = require("../../abi/erc721.abi");
const required_1 = require("../../helpers/required/required");
exports.getNameAdSymbolAndDecimalsERC20 = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
    const { chainId, address } = parameters;
    let defaultSymbol;
    let defaultDecimals;
    let defaultName;
    if (parameters.default) {
        defaultName = parameters.default.name;
        defaultSymbol = parameters.default.symbol;
        defaultDecimals = parameters.default.decimals;
    }
    required_1.requiredDefined(chainId, 'chainId must be defined');
    required_1.requiredDefined(address, 'contract address must be defined');
    const web3Provider = yield web3Factory_1.web3Factory(chainId);
    const erc20SmartContracts = new web3Provider.eth.Contract(erc20_abi_1.erc20ABI, address);
    const [symbol, decimals, name] = yield Promise.all([
        erc20SmartContracts.methods.symbol().call().catch(e => defaultSymbol),
        erc20SmartContracts.methods.decimals().call().catch(e => defaultDecimals),
        erc20SmartContracts.methods.name().call().catch(e => defaultName)
    ]);
    return {
        symbol,
        decimals,
        name
    };
});
exports.getNameAndSymbolERC721 = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
    const { chainId, address } = parameters;
    required_1.requiredDefined(chainId, 'chainId must be defined');
    required_1.requiredDefined(address, 'contract address must be defined');
    let defaultSymbol;
    let defaultName;
    if (parameters.default) {
        defaultName = parameters.default.name;
        defaultSymbol = parameters.default.symbol;
    }
    const web3Provider = yield web3Factory_1.web3Factory(chainId);
    const erc20SmartContracts = new web3Provider.eth.Contract(erc721_abi_1.erc721ABI, address);
    const [symbol, name] = yield Promise.all([
        erc20SmartContracts.methods.symbol().call().catch(e => defaultSymbol),
        erc20SmartContracts.methods.name().call().catch(e => defaultName)
    ]);
    return {
        symbol,
        name
    };
});
//# sourceMappingURL=getSymbolAndName.js.map